import { strings } from "res";
import {
  DashboardIcon,
  OrderIcon,
  ReportIcon,
  SettingIcon,
} from "../assets/svg/icon";
import {
  UserOutlined,
  TagOutlined,
  BranchesOutlined,
  FileOutlined,
  UserSwitchOutlined,
  ScheduleOutlined,
  ProfileOutlined,
  FileSearchOutlined,
  AccountBookOutlined,
  CalendarOutlined,
  TeamOutlined,
  ReadOutlined,
  BankOutlined,
  SnippetsOutlined,
  AppstoreOutlined,
  MessageOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";

import {
  admin_privilege,
  all_privileges,
  dewan_privileges,
  operator_privileges,
  protocol_privileges,
} from "res/privileges/index";

const dashBoardNavTree = [
  {
    key: "Home",
    path: strings.navigation.path.dashboard,
    title: "Home",
    breadcrumb: false,
    access: all_privileges,
    submenu: [
      {
        key: "Dashboard",
        path: strings.navigation.path.dashboard,
        title: "Dashboard",
        icon: DashboardIcon,
        breadcrumb: false,
        access: admin_privilege,
        submenu: [],
      },
      {
        key: "My Activity",
        path: strings.navigation.path.kegiatan_dewan,
        title: "My Activity",
        icon: ScheduleOutlined,
        breadcrumb: false,
        access: dewan_privileges,
        submenu: [],
      },
      {
        key: "Kegiatan",
        path: strings.navigation.path.sidang,
        title: "Kegiatan",
        icon: CalendarOutlined,
        breadcrumb: false,
        access: protocol_privileges,
        submenu: [
          {
            key: "Kegiatan Harian",
            path: strings.navigation.path.activity,
            title: "Kegiatan Harian",
            breadcrumb: false,
            access: protocol_privileges,
            submenu: [],
          },
          {
            key: "Sidang",
            path: strings.navigation.path.sidang,
            title: "Sidang",
            breadcrumb: false,
            access: protocol_privileges,
            submenu: [],
          },
          {
            key: "Undangan",
            path: strings.navigation.path.undangan,
            title: "Undangan",
            breadcrumb: false,
            access: protocol_privileges,
            submenu: [],
          },
        ],
      },
      {
        key: "AKD",
        path: strings.navigation.path.dewan,
        title: "AKD",
        icon: TeamOutlined,
        breadcrumb: false,
        access: admin_privilege,
        submenu: [
          {
            key: "Anggota Dewan",
            path: strings.navigation.path.dewan,
            title: "Anggota Dewan",
            breadcrumb: false,
            access: admin_privilege,
            submenu: [],
          },
          {
            key: "Kepegawaian",
            path: strings.navigation.path.kepegawaian,
            title: "Kepegawaian",
            breadcrumb: false,
            access: admin_privilege,
            submenu: [],
          },
          {
            key: "Komisi",
            path: strings.navigation.path.komisi,
            title: "Komisi",
            breadcrumb: false,
            access: admin_privilege,
            submenu: [],
          },
          {
            key: "Fraksi",
            path: strings.navigation.path.fraksi,
            title: "Fraksi",
            breadcrumb: false,
            access: admin_privilege,
            submenu: [],
          },
        ],
      },
      {
        key: "Berita",
        path: strings.navigation.path.contents,
        title: "Berita",
        icon: ReadOutlined,
        breadcrumb: false,
        access: operator_privileges,
        submenu: [
          {
            key: "Berita",
            path: strings.navigation.path.contents,
            title: "Berita",
            breadcrumb: false,
            access: operator_privileges,
            submenu: [],
          },
          {
            key: "Kategori",
            path: strings.navigation.path.categories,
            title: "Kategori",
            breadcrumb: false,
            access: operator_privileges,
            submenu: [],
          },
          {
            key: "Sub Kategori",
            path: strings.navigation.path.subcategories,
            title: "Sub Kategori",
            breadcrumb: false,
            access: operator_privileges,
            submenu: [],
          },
        ],
      },
      {
        key: "Dokumen",
        path: strings.navigation.path.document,
        title: "Dokumen",
        icon: FileOutlined,
        access: operator_privileges,
        breadcrumb: false,
        submenu: [
          {
            key: "Dokumen",
            path: strings.navigation.path.document,
            title: "Dokumen",
            breadcrumb: false,
            access: operator_privileges,
            submenu: [],
          },
          {
            key: "Image",
            path: strings.navigation.path.image,
            title: "Image",
            breadcrumb: false,
            access: operator_privileges,
            submenu: [],
          },
          {
            key: "Video",
            path: strings.navigation.path.video,
            title: "Video",
            breadcrumb: false,
            access: operator_privileges,
            submenu: [],
          },
        ],
      },
      {
        key: "JDIH",
        path: strings.navigation.path.jdih,
        title: "JDIH",
        icon: BankOutlined,
        breadcrumb: false,
        access: admin_privilege,
        submenu: [],
      },
      {
        key: "Program",
        path: strings.navigation.path.program,
        title: "Program",
        icon: AppstoreOutlined,
        breadcrumb: false,
        access: dewan_privileges,
        submenu: [],
      },
      {
        key: "Aspirasi",
        path: strings.navigation.path.aspirasi,
        title: "Aspirasi",
        icon: MessageOutlined,
        breadcrumb: false,
        access: dewan_privileges,
        submenu: [],
      },
      {
        key: "Reses",
        path: strings.navigation.path.reses,
        title: "Reses",
        icon: EnvironmentOutlined,
        breadcrumb: false,
        access: [...dewan_privileges, ...protocol_privileges],
        submenu: [],
      },
    ],
  },
];

const ControlTree = [
  {
    key: "Pengaturan",
    path: strings.navigation.path.settings,
    title: "Pengaturan",
    breadcrumb: false,
    access: all_privileges,
    submenu: [
      {
        key: "Pengguna",
        path: strings.navigation.path.users,
        title: "Pengguna",
        icon: UserOutlined,
        breadcrumb: false,
        access: admin_privilege,
        submenu: [],
      },
      {
        key: "Pengaturan",
        path: strings.navigation.path.settings,
        title: "Pengaturan",
        icon: SettingIcon,
        breadcrumb: false,
        access: all_privileges,
        submenu: [],
      },
      // https://docs.google.com/document/d/17cddSwHjIPjKvKrnX82aZHfG1AgYJ4Yj1BOVR1dTSgM/edit?usp=sharing
      {
        key: "Panduan",
        path: strings.navigation.path.panduan,
        title: "Panduan",
        icon: FileSearchOutlined,
        breadcrumb: false,
        access: all_privileges,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree, ...ControlTree];

export default navigationConfig;
